import {
  Box,
  LinearProgress,
  Typography
} from '@mui/material';
import _ from 'lodash';
import React, { useState } from 'react';
import * as ds from './dataService';
import {
  Document,
  Page
} from 'react-pdf';
import Big from 'big.js';
import {
  useNavigate,
  useParams
} from 'react-router-dom';



export type FilePdfViewerProps = {
  apiFileId: string;
  scale?: number;
  // isLoading?: boolean;
  width: Big;
};



/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: FilePdfViewerProps) => {

  const { data } = ds.useQuery(props.apiFileId);
  const navigate = useNavigate();
  const params = useParams();

  const [
    numPages,
    setNumPages
  ] = useState<number>();



  const [
    buffer,
    setBuffer
  ] = React.useState<ArrayBuffer | null>(null);

  React.useEffect(
    () => {
      (async () => {
        if (data.url === '') {
          return;
        }
        const file = await fetch(data.url);
        const tempBuffer = await file.arrayBuffer();

        setBuffer(() => tempBuffer);

      })();
      () => {};
    },
    [data]
  );


  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(() => numPages);
  }



  if (buffer) {
    return (
      <Box
        // width={props.useScale ? undefined : props.width.toNumber()}
        borderRadius='.5rem'
      >

        <Document
          file={buffer}
          loading={<Typography variant='h1'>LOADING</Typography>}
          onLoadSuccess={onDocumentLoadSuccess}
        >

          {
            _.times(numPages ? numPages : 0, (i) => (
              <Page
                onDoubleClick={() => {
                  if (!params.planApiFileId) {
                    navigate(`detail/${props.apiFileId}`);
                  }
                }}

                key={`${i}`}
                pageIndex={i}
                devicePixelRatio={1}
                pageNumber={i + 1}
                scale={props.scale ?? 1}
                width={props.width.toNumber()}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            ))
          }
        </Document>
      </Box>

    );
  }
  return (
    <Box
      height='100%'
    >

      <LinearProgress
        sx={{
          margin: 'auto'
        }}
      />
    </Box>
  );
};
